import React from "react"
import {
  Area,
  AreaChart as RechartsAreaChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts"

interface AreaChartProps {
  data: any[]
  categories: {
    category: string
    color: string
  }[]
  index: string
  yAxisWidth?: number
  tooltipTitle?: string
  className?: string
}

export function AreaChart({
  data,
  categories,
  index,
  yAxisWidth = 30,
  tooltipTitle = "Value",
  className,
}: AreaChartProps) {
  return (
    <div className={className}>
      <ResponsiveContainer width="100%" height="100%">
        <RechartsAreaChart
          data={data}
          margin={{
            top: 5,
            right: 5,
            left: 0,
            bottom: 5,
          }}
        >
          <XAxis
            dataKey={index}
            tickLine={false}
            axisLine={false}
            tick={{ fontSize: 12 }}
            tickMargin={8}
          />
          <YAxis
            width={yAxisWidth}
            tickLine={false}
            axisLine={false}
            tick={{ fontSize: 12 }}
            tickMargin={8}
          />
          <Tooltip
            content={({ active, payload }) => {
              if (active && payload && payload.length) {
                return (
                  <div className="rounded-lg border bg-white p-2 shadow-sm">
                    <div className="grid grid-cols-2 gap-2">
                      <div className="flex flex-col">
                        <span className="text-[0.70rem] uppercase text-gray-500">
                          {tooltipTitle}
                        </span>
                        <span className="font-bold text-gray-900">
                          {payload[0].value}
                        </span>
                      </div>
                      <div className="flex flex-col">
                        <span className="text-[0.70rem] uppercase text-gray-500">
                          {index}
                        </span>
                        <span className="font-bold text-gray-900">
                          {payload[0].payload[index]}
                        </span>
                      </div>
                    </div>
                  </div>
                )
              }

              return null
            }}
          />
          {categories.map((category) => (
            <Area
              key={category.category}
              type="monotone"
              dataKey={category.category}
              fill={category.color}
              stroke={category.color}
              fillOpacity={0.15}
              strokeWidth={2}
            />
          ))}
        </RechartsAreaChart>
      </ResponsiveContainer>
    </div>
  )
}